"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModalDialog", {
    enumerable: true,
    get: function() {
        return ModalDialog;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../contexts/Theme");
const _IframePageInfoContext = require("../../contexts/IframePageInfoContext");
const _Backdrop = require("../Backdrop/Backdrop");
const _BodyPortal = require("../BodyPortal/BodyPortal");
const _focustrapreact = /*#__PURE__*/ _interop_require_default(require("focus-trap-react"));
const _ModalContext = require("./ModalContext");
const _ModalInner = require("./ModalInner/ModalInner");
const _SideModalInner = require("./SideModalInner/SideModalInner");
const _ModalFooter = require("./ModalFooter/ModalFooter");
const _FocusTrapContext = require("../../contexts/FocusTrapContext");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ModalDialog = (props)=>{
    const { onHide = ()=>undefined, title, show, size, withFooter, onBack, sideModal } = props;
    const { inIframe } = (0, _react.useContext)(_IframePageInfoContext.IframeResizerContext);
    const theme = (0, _Theme.useTheme)();
    const [headerBorder, setHeaderBorder] = (0, _react.useState)(!theme.isAdmin);
    const [stickyHeader, setStickyHeader] = (0, _react.useState)(false);
    const [stickyFooter, setStickyFooter] = (0, _react.useState)(true);
    const focusRef = (0, _react.useRef)(null);
    const modalBodyRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const isSideModal = sideModal === true;
        if (!inIframe && !isSideModal) {
            return ()=>undefined;
        }
        const orig = document.body.style.overflow;
        document.body.style.overflow = show ? "hidden" : orig;
        return ()=>{
            document.body.style.overflow = orig;
        };
    }, [
        show,
        inIframe,
        sideModal
    ]);
    var _props_scrollable;
    return !show ? null : /*#__PURE__*/ _react.default.createElement(_ModalContext.ModalContext.Provider, {
        value: {
            onHide,
            onBack,
            title,
            scrollable: sideModal === true ? true : (_props_scrollable = props.scrollable) !== null && _props_scrollable !== void 0 ? _props_scrollable : false,
            show,
            modalBodyRef,
            headerBorder,
            setHeaderBorder,
            stickyHeader,
            setStickyHeader,
            stickyFooter,
            setStickyFooter,
            size: size !== null && size !== void 0 ? size : "md",
            withFooter: withFooter !== null && withFooter !== void 0 ? withFooter : _react.Children.toArray(props.children).find((c)=>c.type === _ModalFooter.ModalFooter) != null
        }
    }, /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, props.backdrop !== false ? /*#__PURE__*/ _react.default.createElement(_Backdrop.Backdrop, {
        zIndex: props.zIndex != null ? props.zIndex - 1 : undefined
    }) : null, /*#__PURE__*/ _react.default.createElement(_FocusTrapContext.FocusTrapContext.Provider, {
        value: {
            ref: focusRef
        }
    }, /*#__PURE__*/ _react.default.createElement(_BodyPortal.BodyPortal, null, /*#__PURE__*/ _react.default.createElement(_focustrapreact.default, {
        focusTrapOptions: {
            allowOutsideClick: (e)=>{
                return e.target instanceof Element && // pac-container for google maps autocomplete
                (e.target.matches("[data-escape-focus-trap] *") || e.target.matches(".pac-container *"));
            },
            ...props.focusTrapOptions,
            escapeDeactivates: false
        }
    }, sideModal === true ? /*#__PURE__*/ _react.default.createElement(_SideModalInner.SideModalInner, {
        ...props,
        ref: focusRef
    }) : /*#__PURE__*/ _react.default.createElement(_ModalInner.ModalInner, {
        ...props,
        ref: focusRef
    }))))));
};

//# sourceMappingURL=ModalDialog.js.map